/* Rosterpress AI-styled design brief wizard. Pure helpers are shared with node tests (module.exports);
   the DOM part wires the chip rows to the hidden contact[...] inputs of the Shopify contact form. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.RPDesignWizard = api; if (root.document) api.init(root.document); }
})(typeof self !== 'undefined' ? self : this, function () {
  var IDEA_MAX = 800;
  var REQUIRED = ['team', 'style', 'idea'];
  function isTeam(state) { return !state || state.orderFor !== 'Individual'; }

  function clean(v) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim(); }

  function validate(state) {
    state = state || {};
    var missing = REQUIRED.filter(function (k) { return (k !== 'team' || isTeam(state)) && !clean(state[k]); });
    return { ok: missing.length === 0, missing: missing };
  }

  function buildBrief(state) {
    state = state || {};
    var lines = [];
    function add(label, v) { if (v) lines.push(label + ': ' + v); }
    add('Order for', isTeam(state) ? 'Team' : 'Individual');
    if (isTeam(state)) add('Team', clean(state.team)); else add('Print name', clean(state.printName));
    add('Style', clean(state.style));
    add('Colors', clean(state.colors));
    add('Vibe', clean(state.vibe));
    add('Idea', clean(state.idea).slice(0, IDEA_MAX));
    var files = (state.files || []).map(clean).filter(Boolean);
    if (files.length) lines.push('Files:\n' + files.join('\n'));
    add('Reference link', clean(state.link));
    lines.push('Pins/ball in art: ' + (state.pins === false ? 'no' : 'yes'));
    return lines.join('\n');
  }

  function root_pageshow(fn) {
    if (typeof window !== 'undefined') window.addEventListener('pageshow', function (e) { if (e.persisted) fn(); });
  }

  function init(doc) {
    var form = doc.getElementById('rp-ai-wizard');
    if (!form) return;
    var $ = function (sel) { return form.querySelector(sel); };
    var all = function (sel) { return Array.prototype.slice.call(form.querySelectorAll(sel)); };
    var dlg = $('dialog');
    var opened = false;
    var state = { orderFor: 'Team', printName: '', team: '', style: '', colors: '', vibe: '', idea: '', pins: true, files: [], link: '' };
    var hidden = { OrderFor: $('[name="contact[Order for]"]'), Print: $('[name="contact[Print name]"]'), Team: $('[name="contact[Team]"]'), Style: $('[name="contact[Style]"]'), Colors: $('[name="contact[Colors]"]'),
                   Vibe: $('[name="contact[Vibe]"]'), body: $('[name="contact[body]"]'),
                   Files: $('[name="contact[Files]"]'), Link: $('[name="contact[Reference link]"]') };
    var inputs = { print: $('#rp-w-print'), team: $('#rp-w-team'), colors: $('#rp-w-colors'), idea: $('#rp-w-idea'), link: $('#rp-w-link') };

    var radios = all('input[name="rp-order-for"]');
    function orderValue() { var v = 'Team'; radios.forEach(function (r) { if (r.checked) v = r.value; }); return v; }
    function press(group, btn) {
      all(group).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    }
    function showErrors(missing) {
      var target = { team: inputs.team, style: $('#rp-w-style'), idea: inputs.idea };
      REQUIRED.forEach(function (k) {
        var bad = missing.indexOf(k) !== -1;
        var el = target[k], err = $('[data-err="' + k + '"]');
        if (el) {
          if (bad) { el.setAttribute('aria-invalid', 'true'); if (err) el.setAttribute('aria-describedby', err.id); }
          else { el.removeAttribute('aria-invalid'); el.removeAttribute('aria-describedby'); }
        }
        var row = $('[data-row="' + k + '"]');
        if (row) row.classList.toggle('is-invalid', bad);
        if (err) err.hidden = !bad;
      });
    }
    function sync() {
      state.orderFor = orderValue(); state.printName = inputs.print ? inputs.print.value : '';
      state.team = inputs.team.value; state.colors = inputs.colors.value; state.idea = inputs.idea.value;
      hidden.OrderFor.value = state.orderFor; hidden.Print.value = isTeam(state) ? '' : clean(state.printName);
      hidden.Team.value = isTeam(state) ? clean(state.team) : ''; hidden.Style.value = state.style; hidden.Colors.value = clean(state.colors);
      hidden.Vibe.value = state.vibe;
      state.link = inputs.link ? inputs.link.value : '';
      if (hidden.Files) hidden.Files.value = state.files.join('\n');
      if (hidden.Link) hidden.Link.value = clean(state.link);
      hidden.body.value = buildBrief(state);
    }
    function recheck() { if (form.getAttribute('data-tried')) showErrors(validate(currentState()).missing); }
    function currentState() { state.orderFor = orderValue(); state.team = inputs.team.value; state.idea = inputs.idea.value; if (styleSel) state.style = styleSel.value; return state; }

    // Shirt style: a select; its value is the style (any non-empty option, incl. "Not sure yet", is valid).
    var styleSel = $('#rp-w-style');
    if (styleSel) {
      state.style = styleSel.value;
      styleSel.addEventListener('change', function () { state.style = styleSel.value; recheck(); });
    }
    all('[data-vibe]').forEach(function (b) {
      b.addEventListener('click', function () {
        var same = b.getAttribute('aria-pressed') === 'true';
        state.vibe = same ? '' : b.getAttribute('data-vibe');
        press('[data-vibe]', same ? null : b);
      });
    });
    all('[data-pins]').forEach(function (b) {
      b.addEventListener('click', function () { state.pins = b.getAttribute('data-pins') === 'yes'; press('[data-pins]', b); });
    });
    all('[data-example]').forEach(function (b) {
      b.addEventListener('click', function () { inputs.idea.value = b.getAttribute('data-example'); inputs.idea.focus(); recheck(); });
    });
    radios.forEach(function (r) { r.addEventListener('change', recheck); });
    inputs.team.addEventListener('input', recheck);
    inputs.idea.addEventListener('input', recheck);

    function openDialog() {
      opened = true;
      if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
      else { dlg.setAttribute('open', ''); dlg.classList.add('is-inline'); }
      var n = dlg.querySelector('[name="contact[name]"]'); if (n) n.focus();
    }
    function generate() {
      form.setAttribute('data-tried', '1');
      var r = validate(currentState());
      showErrors(r.missing);
      if (!r.ok) {
        var first = $('[data-row="' + r.missing[0] + '"]');
        if (first && first.scrollIntoView) first.scrollIntoView({ block: 'center' });
        return;
      }
      sync();
      openDialog();
    }

    var go = $('[data-generate]');
    if (go) go.addEventListener('click', generate);
    var close = $('[data-close]');
    function closeDialog() {
      opened = false;
      if (typeof dlg.close === 'function') dlg.close();
      dlg.removeAttribute('open'); dlg.classList.remove('is-inline');
    }
    dlg.addEventListener('close', function () { opened = false; });
    if (close) close.addEventListener('click', closeDialog);
    var send = $('[data-send]');
    root_pageshow(function () { if (send) send.disabled = false; });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT' && !dlg.contains(e.target)) e.preventDefault();
    });
    // Uploads (optional): files go to Shopify through the $0 carrier product first, then the URLs travel with the form.
    var U = typeof window !== 'undefined' ? window.RPDesignUpload : null;
    var ups = all('[data-rp-upload]');
    var upCtx = null;
    if (U && ups.length) {
      if (U.bindDropzone) ups.forEach(U.bindDropzone);
      var wrap = $('[data-rp-uploads]');
      upCtx = U.makeCtx({ form: form, uploads: ups, filesInput: hidden.Files, status: $('[data-rp-dlg-status]'), button: send,
                          variantId: wrap && wrap.getAttribute('data-variant'),
                          onUploaded: function (entries) { state.files = entries.map(U.lineFor); sync(); } });
    }
    form.addEventListener('submit', function (e) {
      var r = validate(currentState());
      if (!r.ok || !opened) { e.preventDefault(); generate(); return; }
      sync();
      if (upCtx && U.handleSubmit(upCtx, e)) return;
      if (send) send.disabled = true;
    });
  }

  return { IDEA_MAX: IDEA_MAX, validate: validate, buildBrief: buildBrief, init: init };
});
